// /**
//  * Parcel - Edit
//  */

// React
import React, { useState, useContext, useEffect } from 'react';
// Context
import AuthContext from '../../../../authContext';

// react hook form
import { useForm, Controller } from 'react-hook-form';

// UI
import theme from '../../../../theme';
import { makeStyles, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  FormHelperText,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Tooltip,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from '../../../../components/Modal';
import AddItemsParcelsList from './editItemsParcelsList';
import AddItemsParcelsForm from './editItemsParcelsForm';
import AddInventoryItemsParcelsForm from './editInventoryItemsParcelsForm';
import EditMobile from '../../mobileView/Edit/edit';
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiClose,
  mdiCubeOutline,
  mdiCounter,
  mdiTableRowHeight,
  mdiTableColumnWidth,
  mdiRuler,
  mdiPlusCircle,
  mdiAlertOctagonOutline,
  mdiCheckCircle,
  mdiInformationOutline,
} from '@mdi/js';

// Client SDK
import Client from 'client-sdk/src/client';
import { GetAllWarehousesRequestBuilder } from 'client-sdk/src/warehouses/warehouses';

// Type
import { Parcel, ParcelItems } from '../../interfaces';
import {
  AddItemCreateParcel,
  AddInventoryItemCreateParcel,
  PayloadUpdate,
} from '../../../parcels/interfaces';
import { Warehouse } from '../../../warehouses/interfaces';
import classes from './edit.module.scss';

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  convertPersianDigit2English,
  checkHourisPast,
  disablePrevDateByHour,
} from '../../../../utils/helpers';
import { Product } from '../../../products/interfaces';
import { Variant } from '../../../products/interfaces';
import {
  getParcelsWithIdAction,
  updateParcelsActions,
  deleteParcelItemsActions,
  createParcelItemsActions,
} from '../../../parcels/actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Store } from '../../../../redux/reducers';
import {
  makeSelectCountList,
  makeSelectError,
  makeSelectList,
  makeSelectLoading,
  makeSelectParcel,
} from '../../../parcels/selectors';

import { useHistory } from 'react-router-dom';
import moment from 'moment';
import ListDimensions from '../../../orderPack/dimensionsList';
import MapPosition from '../../../centers/components/mapPosition';
import windowSize from '../../../../utils/hook/useWindowResize';
import enviroment from 'client-sdk/src/enviroments/enviroment';
import handleNotfication from '../../../../utils/handleNotfication';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

type Props = {
  create: (body: any) => void;
  match: {
    params: {
      id: number;
    };
  };
  parcel: Parcel;
  onClose: () => void;
  warehouseId: number;
  updateParcelsDispatch: (payload: PayloadUpdate) => void;
  getParcelWithIdActionDispatch: (id: number) => void;
  deleteItemDispatch: (payload: Record<string, any>) => void;
  createItemDispatch: (payload: Record<string, any>) => void;
};

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

interface SelectorProps {
  parcelsList: Parcel[];
  parcel: Parcel;
  count: number;
  loading: boolean;
  error: any;
}

type Inputs = {
  agentName: string;
  agentPhoneNumber: string;
  deliveryDate: string;
  pickAddress: string;
  pickDate: string;
  pickTime: string;
  deliveryTime: string;
  destinationId: number;
  deliveryType: string;
  id: number;
  items: ParcelItems[];
  deliveryStartTime: string;
  deliveryEndTime: string;
  sourceId: number;
  status: string;
  sourceWarehouseName: string;
  destinationWarehouseName: string;
  inboundType: string
};

function useOnMount(handler: any) {
  return React.useEffect(handler, []);
}

function required(displayName: any) {
  return function validateRequired(value: any) {
    return value !== null || `${displayName} is required.`;
  };
}

const inboundItems = [
  {
    name: "shrink",
    label: "شیرینک",
    info: "در این سرویس تمامی کالا های موجود در محموله با استفاده از پلاستیک حرارت دیده روکش می‌شوند."
  },
  {
    name: "labelAttachment",
    label: "الصاق لیبل",
    info: "لیبل و یا برچسب اختصاصی که میتواند شامل قیمت، لوگو و یا دیگر اطلاعات مورد نیاز شما باشد بر روی کالاها نصب میشود."
  },
  {
    name: "modifyPackage",
    label: "تغییر در ساختار کالا",
    info: "در صورتی که کالای ارسال شده نیاز به اعمال تغییرات به صورت سطحی در ساختار دارند می‌توانید از این سرویس استفاده نمایید."
  },
  {
    name: "repackage",
    label: "تغییر بسته‌بندی",
    info: "در این سرویس کالاهای محموله میتواند در هنگام ورود بسته‌بندی شوند و یا تغیراتی در بسته‌بندی کالاها اعمال شود."
  },
  {
    name: "kitting",
    label: "کیتینگ",
    info: "کیتینگ به معنی ساخت یک پکیج فروش با استفاده از چندین کالا است که میتواند به صورت مجزا ارسال شده و تحت عنوان یک کالا جای‌گذاری شود."
  },
]

const QCItems = [
  {
    name: "checkItems",
    label: "بررسی تمام کالا‌ها",
    info: "با انتخاب این گزینه تمامی کالاهای موجود در محموله به صورت تک به تک مورد بررسی قرارمیگیرند"
  },
  {
    name: "checkDate",
    label: "بررسی تاریخ تولید و انقضا",
  },
  {
    name: "test",
    label: "بررسی عملکرد کالا",
  },
  {
    name: "checkContents",
    label: "بررسی محتویات کارتن",
  },
  {
    name: "requestedQc",
    label: "کنترل کیفی درخواستی",
    info: "شما می‌توانید با انتخاب این گزینه کنترل کیفی مورد نظر خود را شخصی سازی نمایید"
  },
]

function Edit(props: Props) {
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const { register, handleSubmit, errors, watch, control, setValue, getValues, reset } =
    useForm<Inputs>({
      defaultValues: {
        deliveryType: '',
        deliveryTime: '',
        inboundType: '',
        deliveryDate: disablePrevDateByHour(14),
        pickDate: disablePrevDateByHour(14),
        pickTime: null,
        deliveryStartTime: null,
        deliveryEndTime: null,
        // inboundType: "NORMAL"
      },
    });

  const [items, setItems] = useState<any>([]);
  const [item, setItem] = useState<any>({});
  const [deliveryType, setDeliveryType] = useState<any>('');
  const [transportationType, setTransportationType] = useState<any>('');
  const [itemDeleted, setItemDeleted] = useState<any>({});
  const [hasExpirationDateTime, setHasExpirationDateTime] =
    React.useState(false);
  const [id, setId] = useState<any>(1);
  const [tab, setTab] = useState(1)
  const [locationModal, setLocationModal] = useState(false);
  const [itemsInfo, setItemsInfo] = useState<any>([]);
  const [inventoryItem, setInventoryItem] = useState<any>({});
  const [productObject, setProductObject] = useState<Product>({});
  const [variantObject, setVariantObject] = useState<Variant>({});
  const [itemCount, setItemCount] = useState<any>(0);
  const [openAddItem, setOpenAddItem] = useState(false);
  const [openAddInventoryItem, setOpenAddInventoryItem] = useState(false);
  const [clearSelected, setClearSelected] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [destinationId, setDestinationId] = useState(enviroment.destinationId as number);
  const [valueWarehouse, setValueWarehouse] = React.useState<Warehouse | null>(
    null
  );
  const [checkSubmit, setCheckSubmit] = React.useState(false as boolean);
  const [parcelsData, setParcelsData] = React.useState({});
  const [options, setOptions] = React.useState<Warehouse[]>([]);
  const [openDimensions, setOpenDimensions] = useState(false as boolean);
  const [openListDimensions, setOpenListDimensions] = useState(
    false as boolean
  );
  const [inboundDescription, setInboundDescription] = useState<string>("")
  const [qcDescription, setQcDescription] = useState<string>("")
  const [packageChoice, setPackageChoice] = useState<string[]>([])
  const [dimensions, setDimensions] = useState<any>([]);
  const [boxCount, setBoxCount] = useState('');
  const [totalBoxCount, setTotalBoxCount] = useState(0);
  const [count, setCount] = useState('');
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const loading = openAutocomplete && options.length === 0;
  const [latLng, setLatLng] = useState({ lat: 0, lng: 0 } as {
    lat: number;
    lng: number;
  });
  const values = getValues();

  useEffect(() => {
    if (values.inboundType == "VIP") {
      setPackageChoice([])
    }
  }, [values.inboundType])

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllWarehousesRequestBuilder()
        .params({
          'status.equals': 'ACTIVE',
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const warehouses = response.data as any;
      if (active) {
        setOptions(warehouses as Warehouse[]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);

  const addDimensions = () => {
    const newDimension = {
      count,
      length,
      width,
      height,
    };
    setDimensions([...dimensions, newDimension]);
    setCount('');
    setLength('');
    setHeight('');
    setWidth('');
  };

  useEffect(() => {
    let totalCount: any = 0;
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count);
    });
    setTotalBoxCount(totalCount);
  }, [dimensions]);

  const checkButtonDisabled = () => {
    const fields = [count, length, width, height];
    return fields.some(field => !field) && totalBoxCount < Number(boxCount);
  };

  const handleCloseDimensions = () => {
    setOpenDimensions(false);
    setBoxCount('');
    setOpenListDimensions(false);
    setDimensions([]);
  };

  const setUpdateStatus = () => {
    setCheckSubmit(true);
  };

  const onSubmit = (data: Inputs) => {
    let ronadTransportationDTO, parcelCustomizedOperationDTO, deliveryStartTime, deliveryEndTime;
    const {
      agentName,
      agentPhoneNumber,
      deliveryDate,
      deliveryTime,
      pickAddress,
      pickTime,
      pickDate,
      description,
      inboundType
    } = data;

    ronadTransportationDTO = {
      lat: latLng.lat,
      lon: latLng.lng,
      pickAddress,
      pickDate: deliveryDate.date ? convertPersianDigit2English(deliveryDate.format('YYYY-MM-DD')) : deliveryDate,
      pickTime: pickTime?.substring(0, 2).concat(':00:00'),
    };

    if (inboundDescription?.length > 500 || qcDescription?.length > 500) {
      // handleNotfication("توضیحات باید حداکثر ۵۰۰ کاراکتر باشد.", "error")
      return;
    }

    parcelCustomizedOperationDTO = {
      parcelId: props.parcel.id,
      shrink: packageChoice.indexOf("shrink") !== -1,
      labelAttachment: packageChoice.indexOf("labelAttachment") !== -1,
      modifyPackage: packageChoice.indexOf("modifyPackage") !== -1,
      repackage: packageChoice.indexOf("repackage") !== -1,
      kitting: packageChoice.indexOf("kitting") !== -1,
      checkItems: packageChoice.indexOf("checkItems") !== -1,
      checkDate: packageChoice.indexOf("checkDate") !== -1,
      test: packageChoice.indexOf("test") !== -1,
      checkContents: packageChoice.indexOf("checkContents") !== -1,
      requestedQc: packageChoice.indexOf("requestedQc") !== -1,
      inboundDescription,
      qcDescription
    }

    if (transportationType === 'PARTNER') {
      ronadTransportationDTO = {};
      deliveryStartTime = convertPersianDigit2English(
        deliveryTime.substring(0, 2).concat(':00:00')
      )
      deliveryEndTime = convertPersianDigit2English(
        deliveryTime.substring(3, 5).concat(':00:00')
      )
    } else {
      deliveryStartTime = convertPersianDigit2English(
        pickTime.substring(0, 2).concat(':00:00')
      )
      deliveryEndTime = convertPersianDigit2English(
        pickTime.substring(3, 5).concat(':00:00')
      )
    }

    addParcel({
      inboundType,
      agentName,
      agentPhoneNumber,
      deliveryType,
      partnerId: authContext?.user?.partnerId,
      id: props.match.params.id,
      deliveryDate: deliveryDate.date ? convertPersianDigit2English(deliveryDate.format('YYYY-MM-DD')) : deliveryDate,
      transportationType,
      description,
      ronadTransportationDTO,
      deliveryStartTime,
      deliveryEndTime,
      destinationId,
      parcelCustomizedOperationDTO,
      shippingDate: convertPersianDigit2English(moment().format('YYYY-MM-DD')),
    });
  };

  const addParcel = (body: any) => {
    setParcelsData(body);
    handleOpenCheckConfirm();
  };

  const createItemsToParcels = (body: AddItemCreateParcel) => {
    const {
      count,
      product,
      variant,
      boxCount,
      category,
      countOfBox,
      hasExpirationDate,
      unitCost,
    } = body;
    setHasExpirationDateTime(hasExpirationDate);
    setId(id + 1);
    setProductObject(product);
    setVariantObject(variant);
    setItemCount(count);
    const idItem = product?.id;
    const variantId = variant?.id;
    const name = product?.name;
    const categoryName = category?.name;
    setItemsInfo([
      ...itemsInfo,
      {
        id,
        productId: idItem,
        count,
        name,
        boxCount,
        countOfBox,
        product,
        variant,
      },
    ]);
    if (variantId) {
      setItem({
        variantId,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    } else {
      setItem({
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    }
    if (hasExpirationDate) {
      setOpenAddInventoryItem(true);
    } else {
      setItems([
        ...items,
        {
          variantId,
          productId: idItem,
          count,
          packageCount: boxCount ?? 1,
          packageAmount: countOfBox ?? Number(count),
          inventoryItems: [
            {
              amount: Number(count),
              unitCost: unitCost ?? 0,
              productionDate: null,
              expirationDate: null,
            },
          ],
        },
      ]);
      setInventoryItem({
        variantId,
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
        inventoryItems: [
          {
            amount: Number(count),
            unitCost: unitCost ?? 0,
            productionDate: null,
            expirationDate: null,
          },
        ],
      });
      setOpenAddItem(false);
    }
  };

  const createInventoryItemsToParcels = (
    body: AddInventoryItemCreateParcel[]
  ) => {
    setInventoryItem({ ...item, inventoryItems: body });
    setItems([...items, { ...item, inventoryItems: body }]);
    setOpenAddInventoryItem(false);
    setOpenAddItem(false);
  };

  const setConfirmDelete = (body: any) => {
    setOpenConfirmDelete(true);
    setItemDeleted(body);
  };

  const handleOpenCheckConfirm = () => {
    setCheckSubmit(true);
  };

  const handleCloseCheckConfirm = () => {
    setCheckSubmit(false);
  };

  const handleClose = () => {
    setOpenConfirmDelete(false);
  };

  const deleteItem = () => {
    const newValue = items.filter((item: any) => item.id !== itemDeleted.id);
    const newValueInfo = itemsInfo.filter(
      (item: any) => item.id !== itemDeleted.id
    );

    setItems(newValue);
    setItemsInfo(newValueInfo);
    setOpenAddItem(false);
    handleClose();
  };

  const deleteItemsToParcels = () => {
    props.deleteItemDispatch({
      id: itemDeleted.id,
      callback: () => deleteItem(),
    });
  };

  useEffect(() => {
    const { id } = props.match.params;
    props.getParcelWithIdActionDispatch(id);
    setOpenAutocomplete(true);
  }, []);

  useEffect(() => {
    if (props.parcel.id) {
      const payload = {
        inboundType: props.parcel.inboundType,
        agentName: props.parcel.agentName,
        agentPhoneNumber: props.parcel.agentPhoneNumber,
        deliveryDate: props.parcel.deliveryDate,
        pickTime: props.parcel.deliveryDate.concat(
          ' ',
          props.parcel.ronadTransportationDTO?.pickTime
        ),
        description: props.parcel.description,
        deliveryStartTime: props.parcel.deliveryDate.concat(' ', props.parcel.deliveryStartTime),
        deliveryEndTime: props.parcel.deliveryDate.concat(' ', props.parcel.deliveryEndTime),
        deliveryTime: props.parcel.deliveryStartTime === '09:00:00'
          ? '09-11'
          : props.parcel.deliveryStartTime === '11:00:00'
            ? '11-13'
            : props.parcel.deliveryStartTime === '14:00:00'
              ? '14-16'
              : '',

      }
      setLatLng({
        lat: props.parcel.ronadTransportationDTO?.lat ?? 0,
        lng: props.parcel.ronadTransportationDTO?.lon ?? 0,
      });
      const parcelItems = props.parcel.items.map((item: any) => {
        let variantName = item.productName;
        for (let i = 0; i <= 2 && item.featureAndValues[i]; i++) {
          variantName = variantName.concat(
            ' - ',
            item.featureAndValues[i].key,
            ' : ',
            item.featureAndValues[i].value
          );
        }

        if (item.sellerName || item.providerName) {
          const sellerName = item.sellerName ?? item.providerName;
          variantName = variantName.concat(' ( ', sellerName, ' )');
        }
        return {
          id: item.id,
          skuId: item.skuId,
          productId: item.skuId,
          count: item.count,
          name: variantName,
          boxCount: item.boxCount,
          countOfBox: item.boxType,
          product: { name: item.productName, code: item.productCode },
          variant: {
            code: item.variantCode,
            features: item.featureAndValues,
            sellerName: item.sellerName,
            providerName: item.providerName,
          },
        };
      });
      const newPackageChoice = [];
      if (props.parcel?.parcelCustomizedOperationDTO) {
        for (let [key, value] of Object.entries(props.parcel.parcelCustomizedOperationDTO)) {
          if (value) {
            newPackageChoice.push(key)
          }
        }
      }
      reset(payload)
      setItemsInfo(parcelItems);
      setPackageChoice(newPackageChoice)
      setDeliveryType(props.parcel.deliveryType);
      setTransportationType(props.parcel.transportationType);
      setInboundDescription(props.parcel.parcelCustomizedOperationDTO?.inboundDescription)
      setQcDescription(props.parcel.parcelCustomizedOperationDTO?.qcDescription)
    }
  }, [props.parcel]);

  useEffect(() => {
    setValue('pickAddress', props.parcel.ronadTransportationDTO?.pickAddress);
  }, [transportationType]);

  useEffect(() => {
    if (props.parcel.id && openAutocomplete && options.length) {
      const currentWarehouse = options.length
        ? options.filter(option => option.id === props.parcel.destinationId)[0]
        : null;
      if (!destinationId && !clearSelected) {
        setValueWarehouse(currentWarehouse);
        setDestinationId(props.parcel.destinationId);
      }
    }
  }, [props.parcel, openAutocomplete, options]);

  useEffect(() => {
    if (destinationId) setOpenAutocomplete(false);
  }, [destinationId]);

  useEffect(() => {
    const { id } = props.match.params;
    if (inventoryItem.variantId)
      props.createItemDispatch({
        body: inventoryItem,
        id,
        callback: () => {
          props.getParcelWithIdActionDispatch(id);
        },
      });
  }, [inventoryItem]);

  const handleCreateParcel = () => {
    const parcelData = { ...parcelsData };
    props.updateParcelsDispatch({
      body: parcelData,
      pagination: {
        page: 0,
        size: 10,
        partnerId: { equals: authContext.user?.partnerId },
      },
      callback: () => {
        setParcelsData({});
        history.push('/parcels-sender');
      },
    });
    handleCloseDimensions();
    setCheckSubmit(false);
  };

  const handleDeliveryDateChange = (date: any) => {

    // setValue(
    //   'deliveryDate',
    //   convertPersianDigit2English(date.format('YYYY-MM-DD'))
    // );
    setValue('deliveryTime', '');
  };

  useOnMount(() => {
    // register(
    //   { name: 'deliveryDate', type: 'text' },
    //   { validate: required('تاریخ تحویل را وارد کنید') }
    // );
    register({ name: 'pickDate', type: 'text', defaultValue: '' });
    register({ name: 'pickTime', type: 'text', defaultValue: '' });
  });

  const handleChange = event => {
    const index = packageChoice.indexOf(event.target.name)
    if (index > -1) {
      const newChoises = [...packageChoice]
      newChoises.splice(index, 1)
      setPackageChoice(newChoises)
    } else {
      setPackageChoice([...packageChoice, event.target.name]);
    }
  };

  return (
    <>
            <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
              {`
         ویرایش محموله  
         `}
              <span> &nbsp; {props.match.params.id}</span>
            </Typography>

      <form onSubmit={handleSubmit(onSubmit)} className={classes.formWrapper}>
        <Typography className={classes.typographyCards}>
          اطلاعات محموله
        </Typography>
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name="inboundType"
                    label="* نوع محموله"
                    data-cy="inboundType"
                    render={({ onChange, value }) => (
                      <TextField
                        variant="outlined"
                        select
                        fullWidth
                        label="* نوع محموله"
                        onChange={onChange}
                        value={value}
                        error={
                          !!errors.inboundType && !!errors.inboundType
                        }
                      // InputProps={{
                      //   startAdornment: (
                      //     <InputAdornment position="end">
                      //       <Tooltip title="کد دلخواه و منحصر به فرد برای هر سفارش که می‌توانید از طریق آن سفارش خود را در مراحل مختلف پیگیری نمایید">
                      //         <Icon
                      //           path={mdiInformationOutline}
                      //           size={1}
                      //           color={theme.palette.primary.main}
                      //           className={classes.icon}
                      //         />
                      //       </Tooltip>
                      //     </InputAdornment>
                      //   ),
                      // }}
                      >
                        <MenuItem
                          value="NORMAL"
                          data-cy="time1"
                        >
                          عادی
                        </MenuItem>
                        <MenuItem
                          value="VIP"
                          data-cy="time2"
                        >
                          ویژه
                        </MenuItem>
                      </TextField>
                    )}
                  />
                </div>
                <FormHelperText error focused>
                  {errors?.inboundType &&
                    ' نوع محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="transportationTypeLabel">
                      * روش تحویل
                    </InputLabel>
                    <Select
                      label="* روش تحویل"
                      fullWidth
                      id="transportationType"
                      name="transportationType"
                      inputProps={{
                        name: 'transportationType',
                        id: 'transportationType',
                      }}
                      labelId="transportationTypeLabel"
                      value={transportationType}
                      onChange={e =>
                        setTransportationType(e.target.value)
                      }
                      inputRef={register({ required: true })}
                    >
                      <MenuItem value={'PARTNER'} data-cy="fromPartner">
                        ارسال توسط خودم
                      </MenuItem>
                      <MenuItem value={'RONAD'} data-cy="fromRonad">
                        جمع آوری توسط روناد
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <MuiPickersUtilsProvider
                    utils={JalaliUtils}
                    locale="fa"
                  >
                    <Controller
                      rules={{ required: true }}
                      name="deliveryDate"
                      control={control}
                      as={
                        <DatePicker
                          inputVariant="outlined"
                          id="deliveryDate"
                          name="deliveryDate"
                          label="* تاریخ تحویل محموله"
                          format="jYYYY/jMM/jDD"
                          minDate={disablePrevDateByHour(14)}
                          fullWidth
                          disablePast
                          autoOk
                          okLabel={null}
                          cancelLabel={null}
                          // inputRef={register({ required: true })}
                          value={values.deliveryDate}
                          onChange={handleDeliveryDateChange}
                          error={errors.hasOwnProperty('deliveryDate')}
                          helperText={
                            errors.deliveryDate && errors.deliveryDate.message
                          }
                        />
                      }
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <FormHelperText error focused>
                  {errors?.deliveryDate &&
                    'تاریخ تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  {transportationType === 'RONAD' ? (<Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name="pickTime"
                    label={"* بازه تحویل به ناوگان"}
                    data-cy="pickTime"
                    as={
                      <TextField
                        variant="outlined"
                        select
                        fullWidth
                        error={
                          !!errors.pickTime && !!errors.pickTime
                        }
                      >
                        <MenuItem
                          disabled={checkHourisPast(
                            9,
                            values.deliveryDate
                          )}
                          value={'09-15'}
                          data-cy="time1"
                        >
                          {'9 الی 15'}
                        </MenuItem>
                        <MenuItem
                          disabled={checkHourisPast(
                            15,
                            values.deliveryDate
                          )}
                          value={'15-21'}
                          data-cy="time2"
                        >
                          {'15 الی 21'}
                        </MenuItem>
                      </TextField>
                    }
                  />) : (
                    <Controller
                      rules={{ required: true }}
                      style={{ width: '100%' }}
                      control={control}
                      name="deliveryTime"
                      label={"* بازه تحویل محموله"}
                      data-cy="deliveryTime"
                      as={
                        <TextField
                          variant="outlined"
                          select
                          fullWidth
                          error={
                            !!errors.deliveryTime && !!errors.deliveryTime
                          }
                        >
                          <MenuItem
                            disabled={checkHourisPast(
                              9,
                              values.deliveryDate
                            )}
                            value={'09-11'}
                            data-cy="time1"
                          >
                            {'9 الی 11'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              11,
                              values.deliveryDate
                            )}
                            value={'11-13'}
                            data-cy="time2"
                          >
                            {'11 الی 13'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              14,
                              values.deliveryDate
                            )}
                            value={'14-16'}
                            data-cy="time3"
                          >
                            {'14 الی 16'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              14,
                              values.deliveryDate
                            )}
                            value={'16-18'}
                            data-cy="time3"
                          >
                            {'16 الی 18 (ارسال خارج بازه)'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              14,
                              values.deliveryDate
                            )}
                            value={'18-20'}
                            data-cy="time3"
                          >
                            {'18 الی 20 (ارسال خارج بازه)'}
                          </MenuItem>
                        </TextField>
                      }
                    />
                  )}
                </div>
                <FormHelperText error focused>
                  {errors?.deliveryTime &&
                    ' بازه تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              {transportationType === 'RONAD' && <>
                <Grid container item xs={9} alignItems="flex-end">
                  <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="pickAddress"
                        id="pickAddress"
                        label="آدرس جمع آوری"
                        inputRef={register({ required: false })}
                        error={errors.pickAddress && true}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={3} sm={3} lg={3} spacing={2}>
                  <div className={classes.item}>
                    <Button
                      style={{ height: "56px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                      variant="outlined"
                      size="large"
                      component="span"
                      color="default"
                      onClick={() => setLocationModal(true)}>
                      {latLng.lat == 0 ? (<>
                        <span>اضافه کردن موقعیت مکانی</span>
                        <Icon
                          color={theme.palette.primary.main}
                          path={mdiPlusCircle}
                          size={1}
                          style={{ marginRight: "5px" }}
                        />
                      </>) : (
                        <>
                          <span>موقعیت شما با موفقیت ثبت شد</span>
                          <Icon
                            color={theme.palette.green.main}
                            path={mdiCheckCircle}
                            size={1}
                            style={{ marginRight: "5px" }}
                          />
                        </>
                      )}
                    </Button>
                  </div>
                </Grid>
              </>}
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <Controller
                      name="agentName"
                      id="agentName"
                      label={transportationType === 'RONAD' ? "نام مسئول تحویل دهنده" : "نام مسئول حمل"}
                      control={control}
                      rules={{
                        required: false,
                      }}
                      as={
                        <TextField
                          variant="outlined"
                          fullWidth
                          type="text"
                          id="agentName"
                          name="agentName"
                          InputLabelProps={{
                            shrink: !!values.agentName
                          }}
                          // inputRef={register({
                          //   required: false,
                          // })}
                          error={errors.agentName && true}
                        />
                      }
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {errors.agentName?.type === 'required' &&
                    'نام مسئول الزامی می باشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="text"
                      id="agentPhoneNumber"
                      name="agentPhoneNumber"
                      label={transportationType === 'RONAD' ? "شماره مسئول تحویل دهنده(۰۹۱۲۱۲۳۴۵۶۷)" : "شماره مسئول حمل(۰۹۱۲۱۲۳۴۵۶۷)"}
                      inputRef={register({
                        required: false,
                        minLength: 11,
                        maxLength: 13,
                        pattern: /[0-9]/
                      })}
                      InputLabelProps={{
                        shrink: !!values.agentPhoneNumber
                      }}
                      error={errors.agentPhoneNumber && true}
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {(errors?.agentPhoneNumber?.type === 'minLength' ||
                    errors?.agentPhoneNumber?.type === 'maxLength') &&
                    'شماره همراه ۱۱ تا ۱۳ رقم میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'required' &&
                    'شماره‌ همراه مسئول حمل الزامی می باشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText>
              </Grid>
              <Grid item xs={6} sm={6} lg={6}>
                <div className={classes.item}>
                  <Controller
                    name="description"
                    id="description"
                    control={control}
                    rules={{
                      required: false,
                      maxLength: 500
                    }}
                    render={({ onChange, value }) => (
                      <TextField
                        variant="outlined"
                        fullWidth
                        value={value}
                        // inputRef={register({ required: false })}
                        name='description'
                        InputLabelProps={{
                          shrink: !!value
                        }}
                        onChange={onChange}
                        label="توضیحات"
                        data-cy="warehouseAddress"
                      />
                    )}
                  />
                </div>
                <FormHelperText error focused>
                  {errors?.description?.type === 'maxLength' &&
                    'توضیحات باید حداکثر ۵۰۰ کاراکتر باشد.'}
                </FormHelperText>
              </Grid>
              <Grid item md={12} sm={12}>
                <div className='notif' style={{marginTop: "8px"}}>
                  <Icon
                    path={mdiAlertOctagonOutline}
                    size={.8}
                  />
                  <Typography style={{ marginRight: "10px", fontSize: "14px" }}>
                    در اینباند ویژه کالاهای موجود در محموله حداکثر تا 3 ساعت کاری جای‌گذاری شده و با تعرفه ویژه محاسبه می‌شوند.
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Typography className={classes.typographyCards}>
          خدمات مازاد
        </Typography>
        <Card className={classes.card}>
          <CardContent style={{ margin: '14px 0  0', padding: '0 0 12px 0' }}>
            <ul className={classes.tabContainer}>
              <li onClick={() => setTab(1)} className={classes.tabItems + " " + (tab == 1 && classes.active)}>اینباند</li>
              <li onClick={() => setTab(2)} className={classes.tabItems + " " + (tab == 2 && classes.active)}>کنترل کیفی</li>
            </ul>
            {tab == 1 && <Grid container justifyContent='space-between' style={{ marginTop: "24px" }}>
              {inboundItems.map(item => (
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handleChange}
                        checked={packageChoice.includes(item.name)}
                        name={item.name}
                        color="primary"
                        disabled={values.inboundType == "VIP"}
                        size='small'
                      />
                    }
                    label={
                      <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
                        <Typography
                          style={{
                            fontSize: '16px',
                            fontWeight: '400',
                            color: 'rgba(47, 72, 88, 1)',
                          }}
                        >
                          {item.label}
                        </Typography>
                        <HtmlTooltip title={item.info}>
                          <Icon
                            path={mdiInformationOutline}
                            size={.8}
                            color="#217AFF"
                            className={classes.icon}
                          />
                        </HtmlTooltip>
                      </div>
                    }
                  />
                </Grid>
              ))}
              <Grid style={{ marginTop: "30px" }} item xs={12}>
                <div className={classes.item}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    // inputRef={register({ required: false })}
                    value={inboundDescription}
                    name='inboundDescription'
                    placeholder="لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید."
                    label='توضیحات'
                    InputLabelProps={{
                      shrink: true,
                    }}
                    data-cy="warehouseAddress"
                    onChange={e => setInboundDescription(e.target.value)}
                  />
                </div>
                <FormHelperText error focused>
                  {inboundDescription?.length > 500 &&
                    'توضیحات باید حداکثر ۵۰۰ کاراکتر باشد.'}
                </FormHelperText>
              </Grid>
            </Grid>}
            {tab == 2 && <Grid container justifyContent='space-between' style={{ marginTop: "24px" }}>
              {QCItems.map(item => (<Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={handleChange}
                      checked={packageChoice.includes(item.name)}
                      name={item.name}
                      disabled={values.inboundType == "VIP"}
                      color="primary"
                      size='small'
                    />
                  }
                  label={
                    <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
                      <Typography
                        style={{
                          fontSize: '16px',
                          fontWeight: '400',
                          color: 'rgba(47, 72, 88, 1)',
                        }}
                      >
                        {item.label}
                      </Typography>
                      {item.info && <HtmlTooltip title={item.info}>
                        <Icon
                          path={mdiInformationOutline}
                          size={.8}
                          color="#217AFF"
                          className={classes.icon}
                        />
                      </HtmlTooltip>}
                    </div>
                  }
                />
              </Grid>))}
              <Grid style={{ marginTop: "30px" }} item xs={12}>
                <div className={classes.item}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    // inputRef={register({ required: false })}
                    value={qcDescription}
                    name='qcDescription'
                    placeholder="لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید."
                    label="توضیحات"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    data-cy="warehouseAddress"
                    onChange={e => setQcDescription(e.target.value)}
                  />
                </div>
                <FormHelperText error focused>
                  {qcDescription?.length > 500 &&
                    'توضیحات باید حداکثر ۵۰۰ کاراکتر باشد.'}
                </FormHelperText>
              </Grid>
            </Grid>}
            <Grid container className='notif'>
              <Icon
                path={mdiAlertOctagonOutline}
                size={.8}
              />
              <Typography style={{ marginRight: "10px", fontSize: "14px" }}>
                درخواست‌های مورد نظر بر روی تمامی کالاهای محموله اعمال می گردد.
              </Typography>
            </Grid>
          </CardContent>
        </Card>
        {["65", "2", "119"].includes(authContext?.user?.partnerId) && <>
          <Typography className={classes.typographyCards}>
            اطلاعات انبار مقصد
          </Typography>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={3} sm={3} lg={3} spacing={2}>
                  <div className={classes.item}>
                    <Autocomplete
                      style={{ width: '100%' }}
                      open={openAutocomplete}
                      onOpen={() => {
                        setOpenAutocomplete(true);
                      }}
                      onClose={() => {
                        setOpenAutocomplete(false);
                      }}
                      getOptionSelected={(option, value) =>
                        option.name === value.name
                      }
                      getOptionLabel={option => option.name}
                      options={options}
                      loading={loading}
                      onChange={(event: any, newValue: any | null) => {
                        setDestinationId(newValue?.id);
                        setValueWarehouse(newValue);
                      }}
                      renderInput={params => (
                        <TextField
                          variant="outlined"
                          {...params}
                          label="انبار مقصد"
                          inputRef={register({ required: false })}
                          name="admin"
                          id="admin"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress
                                    color="inherit"
                                    size={20}
                                  />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>
                </Grid>
                <Grid item xs={9} sm={9} lg={9} spacing={2}>
                  <div className={classes.item}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      // defaultValue={' '}
                      value={valueWarehouse ? valueWarehouse?.address : ''}
                      label="آدرس انبار"
                      inputProps={{ readOnly: true }}
                      data-cy="warehouseAddress"
                    />
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </>}
        <Typography className={classes.typographyCards}>
          کالاهای محموله
        </Typography>
        <Card className={classes.card}>
          <CardContent style={{ margin: '14px 0  0', padding: '0 16px 24px 16px' }}>
            <Grid container justifyContent='flex-end'>
              <Button
                // style={{ marginBottom: '24px' }}
                variant="outlined"
                color="primary"
                size="large"
                startIcon={<Icon path={mdiPlusCircle} size={1} />}
                onClick={() => {
                  setOpenAddItem(true);
                }}
                data-cy="addProduct"
              >
                {'افزودن کالا به محموله'}
              </Button>
            </Grid>
            <Grid container>
              {itemsInfo.length > 0 && (
                <AddItemsParcelsList
                  data={itemsInfo}
                  deleteItem={(body: any) => setConfirmDelete(body)}
                />
              )}
            </Grid>
          </CardContent>
        </Card>
        <Grid
          container
          justifyContent='flex-end'
        >
          {/* <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={() => window.history.back()}
              style={{
                marginRight: 'auto',
              }}
            >
              {'انصراف'}
            </Button> */}

          <Button
            type="submit"
            size="medium"
            data-cy="saveBtn"
            variant="contained"
            color="primary"
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({ ...watch() })))
                .length === 0
            }
          >
            {'ذخیره محموله '}
          </Button>
        </Grid>
      </form>
      <Dialog open={props.loading} aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <Typography variant="h4" style={{ padding: '100px' }}>
            در حال ذخیره محموله
          </Typography>
          <div className={classes.loadingTitle}>لطفا منتظر بمانید</div>
          <div style={{ textAlign: 'center', marginBottom: '35px' }}>
            <CircularProgress size={58} />
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openConfirmDelete}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div
            className={classes.cancelTitle}
          >{`آیا از حذف ${itemDeleted.name} از محموله اطمینان دارید؟`}</div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={handleClose}
                variant="outlined"
                color="primary"
                size="large"
              >
                {'انصراف'}
              </Button>
              <Button
                variant="contained"
                onClick={deleteItemsToParcels}
                size="large"
                color="primary"
              >
                {'حذف کالا'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={checkSubmit}
        onClose={handleCloseCheckConfirm}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose && (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            )}
          </div>

          <div className={classes.cancelTitle}>
            {`ایا از ویرایش محموله با انبار "${checkSubmit ? valueWarehouse?.name : ''
              }" مطمئنید؟`}
          </div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ marginLeft: '8px' }}
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant="outlined"
                color="primary"
                size="large"
              >
                {'انصراف'}
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={handleCreateParcel}
                size="large"
              >
                {'ذخیره تغییرات'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth="md"
        open={locationModal}
        onClose={() => setLocationModal(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={() => setLocationModal(false)}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <MapPosition
            style={{ height: '400px', width: '500px' }}
            zoom={14}
            center={{ lat: 35.6892, lng: 51.389 }}
            position={latLng}
            setLatlng={(latLng: { lat: number; lng: number }) => {
              setLatLng(latLng);
            }}
          />
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                onClick={() => setLocationModal(false)}
                variant="contained"
                color="primary"
                size="large"
                data-cy="cancelCreateParcel"
              >
                {'تایید'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDimensions}
        onClose={handleCloseDimensions}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDimensions ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDimensions}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.addIcon}>
            <Icon path={mdiCubeOutline} size={4} color="#039590" />
          </div>
          {boxCount && openListDimensions ? (
            <Grid container alignItems="center" spacing={4}>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiCounter} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="count"
                    name="count"
                    value={count}
                    onChange={e => setCount(e.target.value)}
                    label="تعداد"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiTableRowHeight} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="length"
                    name="length"
                    value={length}
                    onChange={e => setLength(e.target.value)}
                    label="طول"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiTableColumnWidth} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="width"
                    name="width"
                    value={width}
                    onChange={e => setWidth(e.target.value)}
                    label="عرض"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiRuler} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="height"
                    name="height"
                    value={height}
                    onChange={e => setHeight(e.target.value)}
                    label="ارتفاع"
                  />
                </Grid>
              </Grid>
              {dimensions.length !== 0 && (
                <Grid item xs={12}>
                  <ListDimensions data={dimensions} modal />
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item xs={12}>
                <p>{'تعداد بسته‌بندی های محموله را وارد کنید'}</p>
              </Grid>
              <Grid item xs={1}>
                <Icon path={mdiCounter} size={1} />
              </Grid>
              <Grid item xs={11}>
                <TextField
                  fullWidth
                  id="boxCount"
                  name="boxCount"
                  value={boxCount}
                  onChange={e => setBoxCount(e.target.value)}
                  label="تعداد بسته"
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          {boxCount && openListDimensions ? (
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={
                    totalBoxCount < Number(boxCount)
                      ? addDimensions
                      : setUpdateStatus
                  }
                  variant="contained"
                  color="secondary"
                  disabled={checkButtonDisabled()}
                  size="large"
                >
                  {totalBoxCount >= Number(boxCount)
                    ? 'مرحله بعد'
                    : 'اضافه کردن بسته'}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleClose()}
                  size="large"
                >
                  {'بازگشت'}
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={() => setOpenListDimensions(true)}
                  variant="contained"
                  color="secondary"
                  disabled={!boxCount}
                  size="large"
                >
                  {'مرحله بعد'}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleCloseDimensions()}
                  size="large"
                >
                  {'بستن'}
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddItem(false)}
        open={openAddItem}
        title={
          <Typography
            variant="h6"
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به محموله
          </Typography>
        }
        content={
          <AddItemsParcelsForm
            addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
            onClose={() => setOpenAddItem(false)}
          />
        }
      />

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddInventoryItem(false)}
        open={openAddInventoryItem}
        title={
          <Typography
            variant="h6"
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن تاریخ انقضا
          </Typography>
        }
        content={
          <AddInventoryItemsParcelsForm
            product={productObject}
            variant={variantObject}
            count={itemCount}
            hasExpirationDate={hasExpirationDateTime}
            addItem={(body: AddInventoryItemCreateParcel[]) =>
              createInventoryItemsToParcels(body)
            }
            onClose={() => setOpenAddInventoryItem(false)}
          />
        }
      />
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  parcel: makeSelectParcel(),
  parcelsList: makeSelectList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({ id })),
    updateParcelsDispatch: (payload: PayloadUpdate) =>
      dispatch(updateParcelsActions(payload)),
    deleteItemDispatch: (payload: Record<string, any>) =>
      dispatch(deleteParcelItemsActions(payload)),
    createItemDispatch: (payload: Record<string, any>) =>
      dispatch(createParcelItemsActions(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Edit);
